<template>
   <div class="containerNcm">
        <div class="painel2">
        <img src="/arqlef/arqlef2.svg" alt="" />
        </div>
        <p class="alltxtEmpresa">Exportar Notas |  <span style="font-weight: 400;">{{$store.state.razaoSocial}}</span></p>
        <div style="display:flex;justify-content:flex-end;margin-right:10px;">
            <div @click="abrirModal()" class="abrirFiltro"> 
                Abrir Filtro
            </div>
        </div>        
        <b-modal id="modalDowloand"  ref="modalDowloand" title="Download" >
            <p  style="color: #707070;font-weight: 600;font-size: 18px; margin-top: 10px;"> Quantidades de notas: <span style="color:green;">{{quantNotas}}</span></p>
            <div class="seleXMlDan">
                <div>
            <p style="text-align: left;">Selecione as opções que deseja para o Download:</p>
                <div class="arrumar">
                    <div style="text-align: left;">
                <input type="checkbox" id="xml" name="scales"
                        checked>
                <label for="scales">XML</label><br>
               
              
                    <input type="checkbox" id="danfe" name="horns">
                    <label for="horns">DANFE</label>
                    </div>
                    </div>
                    </div>
             
            </div>
            <p v-show="msg">{{msg}}</p>
            <a :href="link" v-show="link">Clique aqui para baixar suas notas</a>

            <div style="display: flex; justify-content: center; align-items: center;margin-top:20px;"> 
                <div @click="baixar()" style="color: #fff;background: #009188;padding: 10px;margin-bottom: 20px;width:130px;text-align:center; border-radius: 5px; cursor:pointer;">
                    <span v-if="baixarSpiner">Baixar</span>
                    <span v-else style="color:#fff;">
                        <b-spinner label="Loading..."></b-spinner>
                    </span>
                </div>
            </div>
        </b-modal>
               <QuantNotas v-if="!spinerMedio && temFiltro"   :qntNota="somatoria" :estado="estado" /> 
         <div style="padding-left:10px;padding-right:10px;display: flex;justify-content: flex-end;" v-if="!spinerMedio && temFiltro">
            <p style="font-weight: bold; margin-top: 13px; cursor: pointer;  font-size: 15px;    color: rgb(206, 206, 206);   margin-bottom: 0px;" @click="limpaFiltro()">Limpar filtro</p>
        </div> 
        <ModalFiltro @thisDoModalFiltro="thisFiltro = $event" > </ModalFiltro>
        <div v-if="!spinerMedio">
            <OpcoesNotas 
             @valorNota="somatoria = $event"
            @tirarSomataria="temFiltro = $event"
            :existeNota="existeNota" 
                @existeNota="existeNota = $event"
            :notas="notas" 
            :objEnviaNotas="objEnviaNotas" 
             @quantTotal="notasQuant = $event"
            @pegarTag="objEnviaNotas.obj.tag = $event"       
            @getNotas="notas = $event"> 
            </OpcoesNotas>
        </div>
        <div v-else  style="display: flex;justify-content: center;margin-top:100px;">
            <div class="spinerMedio">

            </div>
        </div>
        <br>
        <div class="baixar" v-if="notasQuant >=1 & existeNota">
            <div @click="baixarAll">Baixar Todas</div>
            <div style="margin:0px 30px;" @click="selecionadas"> Baixar Selecionadas</div>
            <div @click="voltar()"> Voltar</div>
        </div>
        <br>
  </div>
</template>

<script>
import config from '../services/config'
import barramento from '@/services/barramento'
import ModalFiltro from '../shared/ModalFiltro.vue'
import OpcoesNotas from '../shared/OpcoesNotas.vue'
import Mixin from '../services/Mixin'
import QuantNotas from '../components/Quantidade.vue'
export default {
    mixins:[Mixin],
     components: {OpcoesNotas,ModalFiltro,QuantNotas},
    data(){
        return{
            estado:'',
            thisFiltro:null,
            link:'',
            msg:'',         
            baixarSpiner:true,
            quantNotas:0,      
            existeNota:true,               
            notasDowloand:[],   
            qntTotalNotas:''         
        }
    },
    methods:{
         async getNotas(){
             this.objEnviaNotasNfe.quantidade = 500000
             this.objEnviaNotasNfe.exportacao = true
             this.objEnviaNotasCte.quantidade = 500000
             this.spinerMedio = true
                this.objEnviaNotas = this.$store.state.tipoNota == 'NFe' ? {"nome":'getNotasV2',"obj":this.objEnviaNotasNfe} : {"nome":'getNotasCte',"obj":this.objEnviaNotasCte}
                let status = await config[this.objEnviaNotas.nome](this.objEnviaNotas.obj)  
                if(status.status >= 400){
                    this.notas = []
                    this.existeNota = false
                    this.notasQuant = 0
                    this.somatoria = 0
                    
                }else{
                    this.existeNota = true
                    this.notas = status.data.lstNotas 
                    this.notasQuant = status.data.quantidadeTotal
                     this.somatoria = status.data.valorTotal
                }   
                  
            this.spinerMedio = false
        },
        async baixar(){        
           
            if(this.baixarSpiner){
                this.dowloandZip.danfe = document.getElementById('danfe').checked
                this.dowloandZip.xml = document.getElementById('xml').checked
                if(this.dowloandZip.danfe || this.dowloandZip.xml){
                    this.baixarSpiner = false
                    let res = await config.dowloandZip(this.$store.state.idEmpresa,this.dowloandZip,this.$store.state.tipoNota)               
                    if(res.status<=204){
                        this.link  = res.data;
                    }else{
                        this.msg = res.data.message
                    }
                    this.baixarSpiner = true
                }
            }
        },        
        baixarAll(){
             
            this.link = ''
            this.msg = ''
            let array = {"danfe": "", "xml": "","chaves":[]}            
            this.notas.forEach(function(value) {                
                array.chaves.push(value.chaveAcesso)
            });
            this.dowloandZip = array           
            this.$refs['modalDowloand'].show()
            this.quantNotas = array.chaves.length
        },
        selecionadas(){
            this.msg =''
            this.link = ''
            let array = {"chaves":[]}            
            this.notasDowloand.forEach(function(value) {
                array.chaves.push(value.chaveAcesso)
            });
            this.$refs['modalDowloand'].show()
            this.quantNotas = array.chaves.length
            this.dowloandZip = array
           console.log(array)
        },
        voltar(){
            this.$router.push({
                name:'notas'
            })
        },
        abrirModal(){           
            this.thisFiltro.show()  
        }
    }, 
    created(){            
        barramento.$on('aplicarFiltro', async (valor,tipo,isFiltro,estado)=>{
            this.estado = estado
            this.notasQuant = 0;
            this.temFiltro = isFiltro
            this.colocarParaFiltrar(valor,tipo)
            this.thisFiltro.hide()
           await   this.getNotas()
             
         })
        barramento.$on('pegarSelecionadas',(dados)=>{
               this.notasDowloand = dados               
               this.quantNotas = dados.size
            })
        document.documentElement.scrollTop = 0;
        this.getNotas()
    }
}
</script>

<style>
.arrumar{
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100px;
}
.seleXMlDan{
display: flex;
align-items: center;
justify-content: center;


}
.seleXMlDan div{
    width: 400px;
}
.seleXMlDan label{
    margin-left: 10px;
}
.baixar{
    display: flex;
    margin:10px 0px;
    justify-content: center;
    color: #009188;
    font-weight: 600;    
    align-items: center;
}
.baixar div:nth-child(2){
    color: #fff;
    background: #009188;
    padding:10px;
    border-radius: 5px;
}
.baixar div{
    cursor: pointer;
}
#modalDowloand .modal-footer{
    display: none;
}
#modalDowloand{
    text-align: center;
}
#modalDowloand___BV_modal_title_ {
    color: #707070;
    font-weight: bold;
}
</style>